import api from '../token';

export const AddEntradaEstoque = async (dados) => {
  try {
    const response = await api.post('/addEntradaEstoque', dados);
    return response.data;
  } catch (error) {
    
    return { success: false, message: error.message };
  }
};

